.btn {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.btn:hover,
.active {
  background: rgba(255, 255, 255, 0.1);
}

.active {
  color: #7ec8ff;
}
